import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from '../../../../shared/services/case.service';
import { UntypedFormBuilder } from '@angular/forms';
import { EquityReleasePurchaseEstateAgentDetailsComponent } from '../../estate-agent-details/equity-release-purchase-estate-agent-details/equity-release-purchase-estate-agent-details.component';
import { ComparerService } from '../../../../shared/utility/comparer';
import { AuditService } from '../../../../shared/services/audit.service';
import { faHistory, faExternalLink} from '@fortawesome/pro-light-svg-icons';
import {AuditFormComponent} from '../../../audit-form/audit-form.component'
import { ModalService } from 'src/app/shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-equity-release-purchase-property-details',
  templateUrl: './equity-release-purchase-property-details.component.html',
  styleUrls: ['./equity-release-purchase-property-details.component.scss']
})
export class EquityReleasePurchasePropertyDetailsComponent implements OnInit {

  @Input() caseId: number;

  dataLoaded: boolean = false;
  viewInit = false;
  faHistory = faHistory;
  faExternalLink = faExternalLink;

  propertyDetails = this.fb.group({
    id: [],
    caseId: [],
    purchaseAddressLine1 : [],
    purchaseAddressLine2 : [],
    purchaseAddressLine3 : [],
    purchaseAddressLine4 : [],
    purchaseAddressLine5 : [],
    purchasePostcode : [],
    propertyIsUnregistered : [],
    titleNumber : [],
    propertyType : [],
    landlordName : [],
    landlordAddressLine1 : [],
    landlordAddressLine2 : [],
    landlordAddressLine3 : [],
    landlordAddressLine4 : [],
    landlordAddressLine5 : [],
    landlordPostcode : [],
    managementCompanyName : [],
    managementCompanyAddressLine1 : [],
    managementCompanyAddressLine2 : [],
    managementCompanyAddressLine3 : [],
    managementCompanyAddressLine4 : [],
    managementCompanyAddressLine5 : [],
    managementCompanyPostcode : [],
    solarPanelsPresent : [],
    solarPanelsOwnedOutright  : [],
    solarPanelsCompany  : [],
    solarPanelsOwnerAddressLine1 : [],
    solarPanelsOwnerAddressLine2 : [],
    solarPanelsOwnerAddressLine3 : [],
    solarPanelsOwnerAddressLine4 : [],
    solarPanelsOwnerAddressLine5 : [],
    solarPanelsOwnerPostcode : [],
    hasSepticTank : [],
    agreedPurchasePrice : [],
    stampDuty : [],
    sellerSolicitorName : [],
    sellerSolicitorEmailAddress : [],
    sellerSolicitorContactNumber : [],
    seller1Name : [],
    seller2Name : [],
    sellerSolicitorAddressLine1 : [],
    sellerSolicitorAddressLine2 : [],
    sellerSolicitorAddressLine3 : [],
    sellerSolicitorAddressLine4 : [],
    sellerSolicitorAddressLine5 : [],
    sellerSolicitorPostcode : [],
    sellerSolicitorReference : [],
    titleGuaranteeType: [],
    chattels: []
  }, { });

  initialDetails = this.fb.group({
    id: [],
    caseId: [],
    purchaseAddressLine1 : [],
    purchaseAddressLine2 : [],
    purchaseAddressLine3 : [],
    purchaseAddressLine4 : [],
    purchaseAddressLine5 : [],
    purchasePostcode : [],
    propertyIsUnregistered : [],
    titleNumber : [],
    propertyType : [],
    landlordName : [],
    landlordAddressLine1 : [],
    landlordAddressLine2 : [],
    landlordAddressLine3 : [],
    landlordAddressLine4 : [],
    landlordAddressLine5 : [],
    landlordPostcode : [],
    managementCompanyName : [],
    managementCompanyAddressLine1 : [],
    managementCompanyAddressLine2 : [],
    managementCompanyAddressLine3 : [],
    managementCompanyAddressLine4 : [],
    managementCompanyAddressLine5 : [],
    managementCompanyPostcode : [],
    solarPanelsPresent : [],
    solarPanelsOwnedOutright  : [],
    solarPanelsCompany  : [],
    solarPanelsOwnerAddressLine1 : [],
    solarPanelsOwnerAddressLine2 : [],
    solarPanelsOwnerAddressLine3 : [],
    solarPanelsOwnerAddressLine4 : [],
    solarPanelsOwnerAddressLine5 : [],
    solarPanelsOwnerPostcode : [],
    hasSepticTank : [],
    agreedPurchasePrice : [],
    stampDuty : [],
    sellerSolicitorName : [],
    sellerSolicitorEmailAddress : [],
    sellerSolicitorContactNumber : [],
    seller1Name : [],
    seller2Name : [],
    sellerSolicitorAddressLine1 : [], 
    sellerSolicitorAddressLine2 : [],
    sellerSolicitorAddressLine3 : [],
    sellerSolicitorAddressLine4 : [],
    sellerSolicitorAddressLine5 : [],
    sellerSolicitorPostcode : [],
    sellerSolicitorReference : [],
    titleGuaranteeType: [],
    chattels: []
  }, { });

  constructor(
              private caseService: CaseService,
              private fb: UntypedFormBuilder,
              public activeModal: NgbActiveModal,
              private comp: ComparerService,
              private auditService: AuditService,
              private modalService: ModalService) {
  
  }

  ngOnInit(): void {
    this.caseService.getEquityReleasePurchasePropertyDetails(this.caseId).subscribe((response : any) => {
      this.propertyDetails.patchValue(response.propertyDetails);
      this.initialDetails.patchValue(response.propertyDetails);
      this.dataLoaded = true;
    });
  }

  ngAfterContentInit() : void {
    this.viewInit = true;
  }


  updateField(){

    this.caseService.updateEquityReleasePurchasePropertyDetails(this.propertyDetails.value).subscribe((response : any) => {

    }, (error : any) => {


    });
  }

  openEstateAgent(){
    this.activeModal.dismiss();
     const modalRef = this.modalService.openLgModal(EquityReleasePurchaseEstateAgentDetailsComponent);
     modalRef.componentInstance.caseId = this.caseId;
  }

  close(){

    if(this.comp.objectsDifferent(this.initialDetails.value, this.propertyDetails.value))
    {
      this.auditService.auditForm(this.caseId, 'PropertyDetails', this.initialDetails.value, this.propertyDetails.value).subscribe((response : any) => {
        this.activeModal.close(true);
      });
    }
    else
      this.activeModal.dismiss();
  }

  openAuditForForm(){

    const modalRef = this.modalService.openWithOptions(AuditFormComponent, {size: 'xl'});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.formName = "PropertyDetails";

  }

}
